import { create } from "zustand";
import { message } from "antd";

import AdminApiCaller from "../config/api/adminapicaller";

const initialState = {
  promoCodes: [],
  promoCodesCount: 0,
  promoCode: {},
  isLoading: false,
  isPromoCodeLoading: false,
  error: null,
};

export const usePromoCodeStore = create((set) => {
  const setPromoCodes = (partial) =>
    set((state) => ({ ...state, ...partial }));

  return {
    ...initialState,
    addPromoCode: async (payload, cb) => {
      try {
        setPromoCodes({ isLoading: true, error: null });
        const res = await AdminApiCaller.Post("/add-promo-code", payload);
        if (res?.status === 200) {
          message.success(res.data.message);
        } else {
          message.error(res.data.message);
        }
        setPromoCodes({ isLoading: false });
        if (cb) cb(res?.data);
      } catch (err) {
        setPromoCodes({ isLoading: false, error: err });
      }
    },
    getPromoCodes: async (payload, cb) => {
      try {
        setPromoCodes({ isLoading: true, error: null });
        const res = await AdminApiCaller.Get("/get-promo-codes", payload);
        if (res?.status === 200) {
          setPromoCodes({
            promoCodes: res.data.promos,
            promoCodesCount: res.data.count,
            isLoading: false,
          });
        } else {
          setPromoCodes({ isLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setPromoCodes({ isLoading: false, error: err });
      }
    },
    getPromoCode: async (payload, cb) => {
      try {
        setPromoCodes({ isPromoCodeLoading: true, error: null });
        const res = await AdminApiCaller.Get(`/get-promo-code?id=${payload?.id}`);
        if (res?.status === 200) {
          setPromoCodes({ promoCode: res.data.promo, isPromoCodeLoading: false });
        } else {
          setPromoCodes({ isPromoCodeLoading: false });
        }
        if (cb) cb(res?.data);
      } catch (err) {
        setPromoCodes({ isPromoCodeLoading: false, error: err });
      }
    },
    updatePromoCode: async (payload, cb) => {
      try {
        setPromoCodes({ isPromoCodeLoading: true, error: null });
        const res = await AdminApiCaller.Put("/update-promo-code", payload);
        if (res?.status === 200) {
          message.success(res.data.message);
        } else {
          message.error(res.data.message);
        }
        setPromoCodes({ isPromoCodeLoading: false });
        if (cb) cb(res?.data);
      } catch (err) {
        setPromoCodes({ isPromoCodeLoading: false, error: err });
      }
    },
    deletePromoCode: async (payload, cb) => {
      try {
        setPromoCodes({ isPromoCodeLoading: true, error: null });
        const res = await AdminApiCaller.Delete(
          `/delete-promo-code?id=${payload.id}`
        );
        if (res?.status === 200) {
          message.success(res.data.message);
        } else {
          message.error(res.data.message);
        }
        setPromoCodes({ isPromoCodeLoading: false });
        if (cb) cb(res?.data);
      } catch (err) {
        setPromoCodes({ isPromoCodeLoading: false, error: err });
      }
    },
    reset: () => set(initialState),
  };
});
